import { ClickAwayListener } from "@material-ui/core";

export default ClickAwayListener;
